import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'

export interface LandlordSummary {
  flats_total: number
  rented_flats_count: number
  available_flats_count: number
  draft_flats_count: number
  rents_total: number
  paid_rents_count: number
  unpaid_rents_count: number
  paid_rents_amount: number
  unpaid_rents_amount: number
}

export const landlordDashboardQueryKey = ['landlord-dashboard']

export function useLandlordDashboard() {
  async function getSummary(): Promise<LandlordSummary> {
    const response = await apiClient.get<LandlordSummary>(
      SNA_PREFIX + 'dashboard/landlord-summary'
    )
    return response.data
  }

  return useQuery({
    queryFn: getSummary,
    queryKey: landlordDashboardQueryKey
  })
}
